import { AoiListResponse, AoiInfoObject, AoiObject, Options } from 'types';
interface ActionType {
  UPLOAD_SHAPE_FILE_START: string;
  UPLOAD_SHAPE_FILE_SUCCESS: string;
  UPLOAD_SHAPE_FILE_FAILURE: string;
  CANCEL_UPLOAD_SHAPE_FILE: string;
  PUT_NEW_AOI_START: string;
  PUT_NEW_AOI_SUCCESS: string;
  PUT_NEW_AOI_FAILURE: string;
  REVERT_NEW_AOI: string;
  UPDATE_GEOJSON_FROM_MAP: string;
  UPDATE_GEOJSON_FROM_BOUNDARY: string;
  GET_AOI_LIST_START: string;
  GET_AOI_LIST_SUCCESS: string;
  GET_AOI_LIST_FAILURE: string;
  GET_CURRENT_AOI_INFO_START: string;
  GET_CURRENT_AOI_INFO_SUCCESS: string;
  GET_CURRENT_AOI_INFO_FAILURE: string;
  GET_PREVIEW_AOI_INFO_START: string;
  GET_PREVIEW_AOI_INFO_SUCCESS: string;
  GET_PREVIEW_AOI_INFO_FAILURE: string;
  SET_AOI_CLIPPED_OBJECT: string;
  UNLOAD_AOI_PAGE: string;
  GET_LGA_BOUNDARIES_OPTION_START: string;
  GET_LGA_BOUNDARIES_OPTION_SUCCESS: string;
  GET_LGA_BOUNDARIES_OPTION_FAILURE: string;
  GET_LGA_BOUNDARY_START: string;
  GET_LGA_BOUNDARY_SUCCESS: string;
  GET_LGA_BOUNDARY_FAILURE: string;
  INTIAL_AOI_PAGE_START: string;
  INTIAL_AOI_PAGE_SUCCESS: string;
  INTIAL_AOI_PAGE_FAILURE: string;
  SET_LAST_VISIT_LIST_PAGE: string;
  SET_AOI_PREVIEW_ID: string;
}

export const AreaOfInterestActionTypes: ActionType = {
  UPLOAD_SHAPE_FILE_START: '@@UPLOAD_SHAPE_FILE_START',
  UPLOAD_SHAPE_FILE_SUCCESS: '@@UPLOAD_SHAPE_FILE_SUCCESS',
  UPLOAD_SHAPE_FILE_FAILURE: '@@UPLOAD_SHAPE_FILE_FAILURE',
  CANCEL_UPLOAD_SHAPE_FILE: '@@CANCEL_UPLOAD_SHAPE_FILE',
  PUT_NEW_AOI_START: '@@PUT_NEW_AOI_START',
  PUT_NEW_AOI_SUCCESS: '@@PUT_NEW_AOI_SUCCESS',
  PUT_NEW_AOI_FAILURE: '@@PUT_NEW_AOI_FAILURE',
  REVERT_NEW_AOI: '@@REVERT_NEW_AOI',
  UPDATE_GEOJSON_FROM_MAP: '@@UPDATE_GEOJSON_FROM_MAP',
  UPDATE_GEOJSON_FROM_BOUNDARY: '@@UPDATE_GEOJSON_FROM_BOUNDARY',
  GET_AOI_LIST_START: '@@GET_AOI_LIST_START',
  GET_AOI_LIST_SUCCESS: '@@GET_AOI_LIST_SUCCESS',
  GET_AOI_LIST_FAILURE: '@@GET_AOI_LIST_FAILURE',
  GET_CURRENT_AOI_INFO_START: '@@GET_CURRENT_AOI_INFO_START',
  GET_CURRENT_AOI_INFO_SUCCESS: '@@GET_CURRENT_AOI_INFO_SUCCESS',
  GET_CURRENT_AOI_INFO_FAILURE: '@@GET_CURRENT_AOI_INFO_FAILURE',
  GET_PREVIEW_AOI_INFO_START: '@@GET_PREVIEW_AOI_INFO_START',
  GET_PREVIEW_AOI_INFO_SUCCESS: '@@GET_PREVIEW_AOI_INFO_SUCCESS',
  GET_PREVIEW_AOI_INFO_FAILURE: '@@GET_PREVIEW_AOI_INFO_FAILURE',
  SET_AOI_CLIPPED_OBJECT: '@@SET_AOI_CLIPPED_OBJECT',
  UNLOAD_AOI_PAGE: '@@UNLOAD_AOI_PAGE',
  GET_LGA_BOUNDARIES_OPTION_START: '@@GET_LGA_BOUNDARIES_OPTION_START',
  GET_LGA_BOUNDARIES_OPTION_SUCCESS: '@@GET_LGA_BOUNDARIES_OPTION_SUCCESS',
  GET_LGA_BOUNDARIES_OPTION_FAILURE: '@@GET_LGA_BOUNDARIES_OPTION_FAILURE',
  GET_LGA_BOUNDARY_START: '@@GET_LGA_BOUNDARY_START',
  GET_LGA_BOUNDARY_SUCCESS: '@@GET_LGA_BOUNDARY_SUCCESS',
  GET_LGA_BOUNDARY_FAILURE: '@@GET_LGA_BOUNDARY_FAILURE',
  INTIAL_AOI_PAGE_START: '@@INTIAL_AOI_PAGE_START',
  INTIAL_AOI_PAGE_SUCCESS: '@@INTIAL_AOI_PAGE_SUCCESS',
  INTIAL_AOI_PAGE_FAILURE: '@@INTIAL_AOI_PAGE_FAILURE',
  SET_LAST_VISIT_LIST_PAGE: '@@SET_LAST_VISIT_LIST_PAGE',
  SET_AOI_PREVIEW_ID: '@@SET_AOI_PREVIEW_ID'
};

export interface AreaOfInterestState {
  shapeFile: File | null;
  previewIdFromFile: number | null;
  geoJsonFromLGA: GeoJSON.GeometryObject | null;
  uploadState: 'initial' | 'processing' | 'success' | 'fail';
  geoJson: GeoJSON.GeometryObject | null;
  aoiUpdateMode: 'file' | 'map' | 'boundary';
  updateState: 'initial' | 'processing' | 'success' | 'fail';
  errMsg: string | { msg: string; details: Record<string, any> };
  loadingState: 'initial' | 'processing' | 'success' | 'fail';
  aoiList: AoiListResponse | null;
  currentInfo: AoiInfoObject | null;
  previewInfo: AoiInfoObject | null;
  clippedWarning: string;
  lgaOptions: Options | string | null;
  currentActiveAoi?: AoiObject | 'empty';
  lastVisitListPage?: number;
  previewId?: number;
}

export enum AREA_OF_INTEREST {
  LIST_PAGE_SIZE = 5
}
